import React, { useState, useRef, useEffect } from 'react';
import { Upload, X, FileText, Phone, Mail, User, Stethoscope } from 'lucide-react';
import 'react-phone-input-2/lib/style.css'
import PhoneField from './PhoneField';

const ConsultationsForm = () => {

    const [selected, setSelected] = useState('Choose Disease*');
    const [formData, setFormData] = useState({
        patientName: '',
        phone: '',
        email: '',
        disease: '',
        healthIssue: '',
        reference: ''
    });
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [isDragging, setIsDragging] = useState(false);

    const handleFileUpload = (files) => {
        const fileArray = Array.from(files);
        const validFormats = ['doc', 'docx', 'gif', 'pdf', 'png', 'jpg', 'jpeg', 'txt', 'xls', 'xlsx'];

        const validFiles = fileArray.filter(file => {
            const extension = file.name.split('.').pop().toLowerCase();
            return validFormats.includes(extension);
        });

        setUploadedFiles(prev => [...prev, ...validFiles]);
    };


    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);




    const diseases = [
        'Choose Disease*',
        'Cardiology Disease',
        'Vascular Disease',
        'Respiratory Disease',
        'Gastroenterology Disease',
        'Blood & Hematology Disease',
        'Brain Surgery',
        'Spine & Spinal Cord Surgery',
        'Stroke & Paralysis',
        'Nephrology & Urology',
        'Cancer & Oncology',
        'Eye',
        'General Surgery',
        'Dental & Maxillofacial Surgery',
        'Nose, Ear & Throat',
        'Orthopedics',
        ' Traditional Chinese Medicine (TCM)',
        'Pediatric Disease',
        'Gynecological Disease',
        'Infertility & IVF',
        'Geriatrics Disease',
        'Arthritis & Joint Pain',
        'Disability due to road accidents',
        'Rehabilitation & Post-surgery Physiotherapy',
        'Endocrine, Diabetics, Obesity',
        'Target Organ Check-Up',
        'Stem Cell Therapy',

    ];


    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        handleFileUpload(e.dataTransfer.files);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const removeFile = (index) => {
        setUploadedFiles(prev => prev.filter((_, i) => i !== index));
    };

    const handleSubmit = () => {
        if (!formData.patientName || !formData.phone || !formData.disease || uploadedFiles.length === 0) {
            alert('Please fill all required fields marked with *');
            return;
        }

        console.log('Form Data:', formData);
        console.log('Uploaded Files:', uploadedFiles);
        alert('Consultation request submitted successfully!');
    };

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (disease) => {
        setSelected(disease);
        setIsOpen(false);
    };


    return (
        <>
            <section class="pricing-appointment section-space">
                <div class="container">
                    <div class="row align-items-end mb-40 mb-sm-30 mb-xs-30">
                        <div class="col-lg-6">
                            <div class="section__title-wrapper">
                                <h5 class="section__subtitle color-theme-primary title-animation"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid" />Take Appointment</h5>

                            </div>
                        </div>

                        <div class="col-lg-6">
                            <div class="pricing-appointment__content-right ">
                                <h2 class="section__title mb-0 title-animation text-3xl font-bold">Square MedTrust Multidisciplinary Team Consultation</h2>
                            </div>
                        </div>
                    </div>

                    <div class="row">

                        <div class="col-lg-4 sidebar__widget-service">
                            <div class="pricing-appointment__contact-item__wrap d-flex flex-column">
                                <div class="pricing-appointment__contact-item d-flex align-items-end">
                                    <div class="pricing-appointment__contact-item-icon d-flex align-items-center justify-content-center">
                                        <i class="fa-solid fa-phone"></i>
                                    </div>
                                    <div class="pricing-appointment__contact-item-text">
                                        <p>Requesting A Call:</p>
                                        <h5 class="mb-0"><a href="tel:6295550129">(+86) 198 1197 6744</a></h5>
                                    </div>
                                </div>

                                <div class="pricing-appointment__contact-item d-flex align-items-end">
                                    <div class="pricing-appointment__contact-item-icon d-flex align-items-center justify-content-center">
                                        <i class="fa-solid fa-clock"></i>
                                    </div>
                                    <div class="pricing-appointment__contact-item-text">
                                        <p>Sunday - Friday:</p>
                                        <h5 class="mb-0">9 am - 8 pm</h5>
                                    </div>
                                </div>

                                <div class="pricing-appointment__contact-item d-flex align-items-end">
                                    <div class="pricing-appointment__contact-item-icon d-flex align-items-center justify-content-center">
                                        <i class="fa-solid fa-location-dot"></i>
                                    </div>
                                    <div class="pricing-appointment__contact-item-text">
                                        <p>SQUARE MEDICAL TECHNOLOGY (SHENZHEN) CO., LTD </p>
                                        <h5 class="mb-0"><a href="https://maps.app.goo.gl/1N77c8d8zieLRaot7">China</a></h5>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-8">
                            <form id="pricing-appointment__form" method="POST" action="" class="pricing-appointment__form mt-md-60 mt-sm-60 mt-xs-60">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="pricing-appointment__form-input">
                                            <input name="name" id="name" type="text" placeholder="Patient name*" />
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="pricing-appointment__form-input">
                                            <input name="email" id="email" type="text" placeholder="Email" />
                                        </div>
                                    </div>

                                    <div className="col-sm-12">

                                        <PhoneField
                                            value={formData.phone}
                                            defaultCountryCode="US"
                                            placeholder="Patient's Phone Number*"
                                            onChange={({ phone, country }) => {
                                                setFormData({ phone, dialCode: country.phone[0] });
                                            }}
                                            onCountryChange={(country) => console.log("Country:", country)}
                                        />


                                    </div>

                                    <div className="col-sm-12">
                                        <PhoneField
                                            value={formData.phone}
                                            defaultCountryCode="US"
                                            placeholder="What's App Number*"
                                            onChange={({ phone, country }) => {
                                                setFormData({ phone, dialCode: country.phone[0] });
                                            }}
                                            onCountryChange={(country) => console.log("Country:", country)}
                                        />


                                        
                                    </div>

                                    
                                    <div class="col-sm-6">

                                        <div className="pricing-appointment__form-select relative w-full" ref={dropdownRef}>
                                            {/* Hidden native select */}
                                            <select name="doctor" id="doctor" className="hidden" value={selected} onChange={() => { }}>
                                                {diseases.map((disease, index) => (
                                                    <option key={index} value={disease}>{disease}</option>
                                                ))}
                                            </select>

                                            {/* Custom dropdown */}
                                            <div
                                                className={`nice-select relative bg-white border border-gray-100 rounded-md cursor-pointer px-4 py-3 pr-10 select-none transition-all duration-200 w-full hover:border-gray-600 focus:outline-none focus:ring-1 focus:ring-blue-500 ${isOpen ? 'border-blue-500' : ''}`}
                                                tabIndex="0"
                                                onClick={() => setIsOpen(!isOpen)}
                                            >

                                                <div class="pricing-appointment__form-input mt-2.5">
                                                    {selected}
                                                </div>

                                                {/* Dropdown arrow */}


                                                {/* Dropdown list with scrolling */}
                                                <ul className={`list absolute left-0 right-0 bg-white border border-gray-100 rounded-md shadow-lg mt-2 p-0 m-0 list-none z-50 max-h-64 overflow-y-auto overflow-x-hidden transition-all duration-200 ${isOpen ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2'}`}>
                                                    {diseases.map((disease, index) => (
                                                        <li
                                                            key={index}
                                                            data-value={disease}
                                                            className={`option px-4 cursor-pointer text-gray-700 text-2xl transition-colors duration-150 hover:bg-gray-100 ${selected === disease ? 'bg-blue-950 text-white hover:bg-green-600' : ''}`}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleSelect(disease);
                                                            }}
                                                        >
                                                            {disease}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>

                                            {/* Custom scrollbar styles */}
                                            <style jsx>{`
                .list::-webkit-scrollbar {
                    width: 8px;
                }
                .list::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                .list::-webkit-scrollbar-thumb {
                    background: #888;
                    border-radius: 4px;
                }
                .list::-webkit-scrollbar-thumb:hover {
                    background: #555;
                }
            `}</style>
                                        </div>


                                    </div>
                                    <div class="col-sm-6">
                                        <div class="pricing-appointment__form-input">
                                            <input name="phone" id="phone" type="text" placeholder="Reference (Optional)" />
                                        </div>

                                    </div>
                                    {/* <div class="col-sm-12">

                                        <div class="pricing-appointment__form-input" >
                                            <textarea name="textarea" id="textarea" style={{ fontSize: 15 }} placeholder="Patient&#39;s health issue and current medication"></textarea>
                                        </div>

                                        <div className="sm:col-span-2">
                                            <div
                                                onDrop={handleDrop}
                                                onDragOver={handleDragOver}
                                                onDragLeave={handleDragLeave}
                                                className={`border-2 border-dashed rounded-md p-8 text-center transition-all ${isDragging
                                                    ? 'border-green-500 bg-green-50'
                                                    : 'border-gray-300 bg-gray-50'
                                                    }`}
                                            >
                                                
                                               
                                                <input
                                                    type="file"
                                                    multiple
                                                    onChange={(e) => handleFileUpload(e.target.files)}
                                                    accept=".doc,.docx,.gif,.pdf,.png,.jpg,.jpeg,.txt,.xls,.xlsx"
                                                    className="hidden"
                                                    id="fileUpload"
                                                />
                                                <div class="col-sm-2">
                                                <label
                                                    htmlFor="fileUpload"
                                                    className="inline-block bg-gray-300 text-black px-6 py-2 rounded-md cursor-pointer hover:bg-gray-300 transition text-lg font-medium"
                                                >
                                                   Choose File
                                                  
                                                </label>
                                                
                                                </div>

                                                 
                                                
                                                
                                            </div>


                                            {uploadedFiles.length > 0 && (
                                                <div className="mt-4 space-y-2">
                                                    {uploadedFiles.map((file, index) => (
                                                        <div
                                                            key={index}
                                                            className="flex items-center justify-between bg-green-50 p-3 rounded-md border border-green-100"
                                                        >
                                                            <div className="flex items-center gap-3">
                                                                <FileText className="w-5 h-5 text-green-600" />
                                                                <div>
                                                                    <p className="text-sm font-medium text-gray-800">{file.name}</p>
                                                                    <p className="text-xs text-gray-500">{formatFileSize(file.size)}</p>
                                                                </div>
                                                            </div>
                                                            <button
                                                                onClick={() => removeFile(index)}
                                                                className="text-red-500 hover:text-red-700"
                                                            >
                                                                <X className="w-5 h-5" />
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                        </div>

                                        




                                        <div className='mt-2'>
                                            <h3 className="text-gray-600 mb-2 text-2xl">
                                                    Drag and drop a file here or click to select a file. Supported formats are (DOC, DOCX, GIF, PDF, PNG, JPG, JPEG, TXT, XLS, and XLSX.)
                                                </h3>
                                        </div>

                                    </div> */}

                                    <div class="col-sm-12">
                                        <div class="pricing-appointment__form-input">
                                            <textarea name="textarea" id="textarea" placeholder="Messege"></textarea>
                                        </div>
                                    </div>

                                    <div className="sm:col-span-2 space-y-2">
                                        {/* File input row */}
                                        <div className="flex items-center gap-4 border border-gray-300 rounded-md px-4 py-4 w-full">
                                            {/* Hidden input */}
                                            <input
                                                type="file"
                                                id="fileUpload"
                                                multiple
                                                onChange={(e) => handleFileUpload(e.target.files)}
                                                accept=".doc,.docx,.gif,.pdf,.png,.jpg,.jpeg,.txt,.xls,.xlsx"
                                                className="hidden"
                                            />

                                            {/* Choose file button */}
                                            <label
                                                htmlFor="fileUpload"
                                                className="bg-gray-200 text-black px-4 py-1.5 rounded-md cursor-pointer hover:bg-gray-300 transition text-lg font-medium"
                                            >
                                                Choose File
                                            </label>

                                            {/* File status */}
                                            <span className="text-lg text-gray-600">
                                                {uploadedFiles.length > 0
                                                    ? `${uploadedFiles.length} file(s) selected`
                                                    : 'no file selected'}
                                            </span>
                                        </div>

                                        {/* Helper text */}
                                        <h3 className="text-gray-600 mb-2 text-2xl">
                                            Drag and drop a file here or click to select a file. Supported formats are (DOC, DOCX, GIF, PDF, PNG, JPG, JPEG, TXT, XLS, and XLSX.)
                                        </h3>
                                    </div>




                                    <div class="col-12">
                                        <button type="submit" class="rr-btn rr-btn__primary-color mt-9">
                                            <span class="btn-wrap">
                                                <span class="text-one">submit</span>
                                                <span class="text-two">submit</span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default ConsultationsForm;






